import { Flex, Image, Spin } from 'antd';
import { useLoaderStore } from './loaderStore';

// Spinner de ondas elegante
const SimpleSpinner = ({ size = 280 }: { size?: number }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="flex items-center justify-center">
        <Image src={'/assets/gif/loader.gif'} alt="Cargando..." height={size} preview={false} />
      </div>

      <div className="mt-6 text-center font-semibold tracking-wide" style={{ fontSize: '16px', color: '#6B7280' }}>
        Cargando
        <span className="dots-animate">
          <span style={{ animationDelay: '0s' }}>.</span>
          <span style={{ animationDelay: '0.2s' }}>.</span>
          <span style={{ animationDelay: '0.4s' }}>.</span>
        </span>
      </div>
    </div>
  );
};

// Spinner principal fullscreen
const Spinner = () => {
  const isLoading = useLoaderStore((state) => state.isLoading);
  return <Spin spinning={isLoading} fullscreen indicator={<SimpleSpinner size={240} />} />;
};

// Para usar inline
export const InlineSpinner = ({ size = 280 }: { size?: number }) => (
  <Flex className="fixed inset-0" align="center" justify="center">
    <SimpleSpinner size={size} />
  </Flex>
);

export default Spinner;
